import axios from 'axios';
import { newAbortSignal } from '../../utils';
import { SessionStore } from '../../types/store/SessionStore';
import { Project } from '../../types/interfaces/project';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/account/`;

export const getAccountProjects = async (accountId: number): Promise<Project[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem('session') || '{}'
  );

  const finalURL = `${BASE_URL}${accountId}/projects`;

  return await axios
    .get(finalURL, {
      headers: {
        'content-type': 'application/json',
        'x-access-token': session?.accessToken,
      },
      timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        typeof AbortSignal.timeout !== 'undefined'
          ? AbortSignal.timeout(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`))
          : newAbortSignal(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
    })
    .then((response) => {
      return response.data; 
    })
    .catch((error) => {
      console.error("Erro ao buscar projetos:", error);
      return [];
    });
};
